module.exports = __webpack_public_path__ + "static/competicao-3-30efbdb5002aad7f8f9a1e2cf5c8c2b9.jpeg";